import * as form from '../form';

export const psychologicalExisting = (data = {}) => {
  const items = ((data.TreatmentList || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Condition: form.text(xitem.Condition),
        Diagnosed: form.daterange(xitem.Diagnosed),
        Treatment: form.treatment(xitem.Treatment),
        TreatmentFacility: form.treatment(xitem.TreatmentFacility),
        Effective: form.branch(xitem.Effective),
        Explanation: form.textarea(xitem.Explanation),
        Comments: form.textarea(xitem.Comments),
      },
    };
  });
  return {
    HasCondition: form.branch(data.HasCondition),
    ReceivedTreatment: form.radio(data.ReceivedTreatment),
    Explanation: form.textarea(data.Explanation),
    TreatmentList: form.collection(items, (data.TreatmentList || {}).branch),
    DidNotFollow: form.branch(data.DidNotFollow),
    DidNotFollowExplanation: form.textarea(data.DidNotFollowExplanation),
    Comments: form.textarea(data.Comments),
    ReceivedTreatmentComments: form.textarea(data.ReceivedTreatmentComments),
    ReceivedTreatmentSummaryComments: form.textarea(data.ReceivedTreatmentSummaryComments),
    DidNotFollowComments: form.textarea(data.DidNotFollowComments),
    DidNotFollowExplanationComments: form.textarea(data.DidNotFollowExplanationComments),
    DidNotReceiveTreatmentComments: form.textarea(data.DidNotReceiveTreatmentComments),
    HasPsychosis: form.branch(data.HasPsychosis),
    HasManic: form.branch(data.HasManic),
    HasImpulsive: form.branch(data.HasImpulsive),
    HasPlanToHurt: form.branch(data.HasPlanToHurt),
  };
};
